/**
* For animating any value that we want to change, with an ease out:
*   angle, position (two of these to animate in 2-space), transparency, etc.
*/

export function initializeDecelerationPath({ initialValue, finalValue, runSeconds, decelerationSeconds }) {
  // d1 = Vi * t1
  // d2 = Vi * t2 - 1/2 a * t2^2
  // d = d1 + d2
  // Vi = a * t2
  // which gives: a = Vi / t2
  // so: d = Vi * t1 + Vi * t2 - 1/2 a * t2^2
  // and substituting for a:
  // d = Vi * t1 + Vi * t2 - 1/2 (Vi / t2) * t2^2
  // which reduces to:
  // d = Vi * t1 + 1/2 Vi * t2
  // giving:
  // Vi = d / (t1 + 1/2 t2)
  runSeconds = Math.max(runSeconds, decelerationSeconds); //ensure that total time is at least as long as deceleration time

  if (runSeconds === 0) initialValue = finalValue;

  const constantVelocitySeconds = runSeconds - decelerationSeconds;
  const distance = finalValue - initialValue;
  const initialVelocity = distance / (constantVelocitySeconds + 0.5 * decelerationSeconds);

  return {
    acceleration: decelerationSeconds === 0 ? 0 : initialVelocity / decelerationSeconds,
    baseMilliseconds: Date.now(),
    constantVelocitySeconds,
    decelerationSeconds,
    initialValue,
    initialVelocity,
  };
}

export function currentDecelerationPathPosition ({
    acceleration,
    baseMilliseconds,
    constantVelocitySeconds,
    decelerationSeconds,
    initialValue,
    initialVelocity,
  }) {
  const elapsedSeconds = computeElapsedSeconds({ baseMilliseconds, constantVelocitySeconds, decelerationSeconds });
  const elapsedConstantVelocitySeconds = Math.min(elapsedSeconds, constantVelocitySeconds);
  decelerationSeconds = Math.min(elapsedSeconds - elapsedConstantVelocitySeconds, decelerationSeconds);
  const d1 = initialVelocity * elapsedConstantVelocitySeconds;
  const d2 = initialVelocity * decelerationSeconds - 0.5 * acceleration * decelerationSeconds * decelerationSeconds;
  return initialValue + d1 + d2;
}

export function isDecelerationAnimationFinished({
    baseMilliseconds,
    constantVelocitySeconds,
    decelerationSeconds,
  }) {
  return computeElapsedSeconds({ baseMilliseconds, constantVelocitySeconds, decelerationSeconds }) >= constantVelocitySeconds + decelerationSeconds;
}

function computeElapsedSeconds({ baseMilliseconds, constantVelocitySeconds, decelerationSeconds }) {
  return Math.min((Date.now() - baseMilliseconds) / 1000.0, constantVelocitySeconds + decelerationSeconds);
}
